import React, { useEffect } from "react";
import { WizardFormData } from "../types/wizard.types";
import AppStoreIcon from "../../../assets/img/brands/download-on-apple-app-store.svg";
import GooglePlayImage from "../../../assets/img/brands/get-on-google-play.png";

interface MemberAppStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const MemberAppStep: React.FC<MemberAppStepProps> = ({
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  // TODO: GRWTH-903 - show these in an experiment
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const appStoreComponents = () => (
    <div className="tw-space-y-3 tw-space-x-3">
      {/* Apple App Store */}
      <a
        href="https://apps.apple.com/us/app/pushpress-members/id1309909578"
        target="_blank"
        rel="noopener noreferrer"
        className="tw-inline-block tw-transition-all hover:tw-opacity-80"
      >
        <AppStoreIcon className="tw-h-8 tw-w-auto" />
      </a>
      {/* Google Play Store */}
      <a
        href="https://play.google.com/store/apps/details?id=com.pushpress.memberportal&hl=en_US&gl=US&pli=1"
        target="_blank"
        rel="noopener noreferrer"
        className="tw-inline-block tw-transition-all hover:tw-opacity-80"
      >
        <img
          src={GooglePlayImage}
          alt="Get it on Google Play"
          className="tw-h-8 tw-w-auto"
        />
      </a>
    </div>
  );

  return (
    <div>
      <div className="tw-mb-4">
        <div className="tw-space-y-2">
          <div>
            <p className="tw-font-semibold tw-text-neutral-800">
              Self-Serve Success
            </p>
            <p className="tw-pb-1 tw-text-neutral-800/80">
              Members manage everything, freeing your staff and slashing admin
              time.
            </p>
          </div>
          <div>
            <p className="tw-font-semibold tw-text-neutral-800">
              Sticky Memberships
            </p>
            <p className="tw-pb-1 tw-text-neutral-800/80">
              Keep them engaged with easy booking, progress tracking, and
              instant updates.
            </p>
          </div>
          <div>
            <p className="tw-font-semibold tw-text-neutral-800">
              Direct-to-Pocket Comms
            </p>
            <p className="tw-pb-1 tw-text-neutral-800/80">
              Deliver vital news and offers straight to their phones, no missed
              messages.
            </p>
          </div>
          <div>
            <p className="tw-font-semibold tw-text-neutral-800">
              Cultivate Community
            </p>
            <p className="tw-pb-1 tw-text-neutral-800/80">
              A central hub for members to connect, stay informed, and love your
              gym even more.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberAppStep;
